<template>
  <svg
    height="47"
    viewBox="0 0 45 47"
    width="45"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="a"
      fill="#fff"
    ><path
      d="m0 .6951h44.3047v44.3049h-44.3047z"
      fill="#fff"
      fill-rule="evenodd"
    /></mask>
    <g
      fill="none"
      fill-rule="evenodd"
    >
      <path
        d="m44.3047 22.8481c0 12.235-9.918 22.152-22.15 22.152-12.236 0-22.155-9.917-22.155-22.152 0-12.234 9.919-22.153 22.155-22.153 12.232 0 22.15 9.919 22.15 22.153"
        fill="#fff"
        mask="url(#a)"
        transform="translate(0 .3047)"
      />
      <path
        d="m22.1533 45.0122c8.82 0 16.416-5.228 19.871-12.752h-39.746c3.456 7.524 11.054 12.752 19.875 12.752"
        fill="#008d46"
      />
      <path
        d="m22.1533 1.2915c-8.821 0-16.419 5.229-19.875 12.751h39.746c-3.455-7.522-11.051-12.751-19.871-12.751"
        fill="#d2232c"
      />
      <path
        d="m.291 23.1519c0 3.251.714 6.335 1.987 9.108h39.746c1.274-2.773 1.987-5.857 1.987-9.108 0-3.252-.713-6.336-1.987-9.109h-39.746c-1.273 2.773-1.987 5.857-1.987 9.109"
        fill="#fff"
      />
    </g>
  </svg>
</template>
